import { Modal, Select, Text } from '@viapeople/components'
import { useState } from 'react'
import { useFormBuilderStore } from '../store'
import { PREVIEW_ROLE_OPTIONS, type PreviewRoleType } from '../types/preview'
import { FormPreviewRenderer } from './FormPreviewRenderer'

interface PreviewFormModalProps {
	isOpen: boolean
	onClose: () => void
}

export function PreviewFormModal({ isOpen, onClose }: PreviewFormModalProps) {
	const [selectedRole, setSelectedRole] = useState<PreviewRoleType>('participant')
	const formName = useFormBuilderStore((state) => state.formName)

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			fullContent
			fullScreen
			title={formName ? `Preview: ${formName}` : 'Form Preview'}
			bodyClassName='overflow-y-auto'>
			<div className='flex flex-col h-full'>
				{/* Header with role selector */}
				<div className='sticky top-0 bg-neutral-0 border-b border-neutral-200 px-6 py-4 z-10'>
					<div className='flex items-center justify-between max-w-4xl mx-auto'>
						<div className='flex items-center gap-4'>
							<Text variant='small' className='text-neutral-600'>
								Preview as:
							</Text>
							<Select
								value={selectedRole}
								onChange={(value: string) => setSelectedRole(value as PreviewRoleType)}
								options={PREVIEW_ROLE_OPTIONS}
								className='w-48'
							/>
						</div>
						<Text variant='xsmall' className='text-neutral-400'>
							Changes made in preview are not saved
						</Text>
					</div>
				</div>

				{/* Form preview content */}
				<div className='flex-1 px-6 py-8 bg-neutral-50'>
					<div className='max-w-4xl mx-auto bg-neutral-0 rounded-lg shadow-sm border border-neutral-200 p-8'>
						<FormPreviewRenderer selectedRole={selectedRole} />
					</div>
				</div>
			</div>
		</Modal>
	)
}
